import React from 'react'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import logo from "../Images/logo black.png"
import "../Sass/Home.scss"

const Header = () => {

    const [open, setOpen] = useState('none');

    const show = () => {
        setOpen("block");
    }

    const hide = () => {
        setOpen("none");
    }

    const up = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setOpen("none");
    }

    return (
        <>
            <div className="header">
                <img src={logo} alt="logo" />
                <ul className="menu-bar">
                    <Link to="/" className='link'>home</Link>
                    <Link to="/#about" className='link' onClick={hide}>about</Link>
                    <Link to="/#services" className='link' onClick={hide}>services</Link>
                    <Link to="/#contact" className='link' onClick={hide}>contact</Link>
                </ul>
                {/* <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1694512540/Think_Tank/Icons/menu-blue_jhbco2_n0agt2.webp" alt="menu" className="menu-icon" onClick={show} /> */}
                <svg className="menu-icon" onClick={show} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 24 24">
                    <path d="M 2 5 L 2 7 L 22 7 L 22 5 L 2 5 z M 2 11 L 2 13 L 22 13 L 22 11 L 2 11 z M 2 17 L 2 19 L 22 19 L 22 17 L 2 17 z"></path>
                </svg>
            </div>
            <div className="header-mobile" id="mobile-menu" style={{ display: open }}>
                <img src="https://res.cloudinary.com/ddwk3hbiu/image/upload/v1694512533/Think_Tank/Icons/close_ihrols_snje2a.webp" alt="menu" className="menu-icon" onClick={hide} />

                <ul className="menu-bar" >
                    <Link to="/" onClick={up}>home</Link>
                    <Link to="/#about" className='link' onClick={hide}>about</Link>
                    <Link to="/#services" className='link' onClick={hide}>services</Link>
                    <Link to="/#contact" className='link' onClick={hide}>contact</Link>

                </ul>
            </div>

        </>
    )
}

export default Header
